import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { UiModule } from '@shabic/ui';

@NgModule({
  declarations: [CarouselComponent],
  imports: [CommonModule, UiModule],
  exports: [CarouselComponent],
})
export class CarouselModule {}
